import { EstablishmentModel } from 'src/app/core/models/establishment.model';

export class SetCurrentEstablishment {
  static readonly type = '[Establishment] Set Current Establishment';

  constructor(public readonly payload: EstablishmentModel) {}
}
